import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderWithTextOutline = createIcon({
  displayName: 'FolderWithTextOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M8.01,17h7.98"></path>
        <path d="M8.01,13h7.98"></path>
        <path d="M19,9h-6.465c-0.334,0 -0.647,-0.167 -0.832,-0.445l-1.406,-2.109c-0.186,-0.279 -0.498,-0.446 -0.832,-0.446h-4.465c-1.105,0 -2,0.895 -2,2v11c0,1.105 0.895,2 2,2h14c1.105,0 2,-0.895 2,-2v-8c0,-1.105 -0.895,-2 -2,-2Z"></path>
        <path d="M5,6v-1c0,-1.105 0.895,-2 2,-2h10c1.105,0 2,0.895 2,2v4"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24v-24Z"></path>
    </>
  ),
})

const FolderWithText: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderWithTextTwoTone} {...props} />

  return <CustomIcon as={FolderWithTextOutline} {...props} />
}

export default memo(FolderWithText)
